import { create } from 'zustand';

export type NotificationKind = 'success' | 'info' | 'error';

export interface NotificationEntry {
  id: string;
  kind: NotificationKind;
  message: string;
  createdAt: number;
  duration: number | null;
}

interface NotificationState {
  items: Record<string, NotificationEntry>;
  upsert: (entry: NotificationEntry) => void;
  remove: (id: string) => void;
  clear: () => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
  items: {},
  upsert: (entry) =>
    set((s) => ({ items: { ...s.items, [entry.id]: entry } })),
  remove: (id) =>
    set((s) => {
      if (!s.items[id]) return s;
      const next = { ...s.items };
      delete next[id];
      return { items: next };
    }),
  clear: () => set({ items: {} }),
}));
